import React, {useEffect} from 'react';

import {useShellSelectedAccount} from '../../../shell/ShellSelectedAccountContext';
import {isMountedInShell} from '../../../shellRemote';
import {useAccountSelectorContext} from './AccountSelectorContextProvider';
import {AccountSelectorContextProviderWrapper} from './AccountSelectorContextProviderWrapper';
import {ShellAdminModals} from './ShellAdminModals';
import {AccountType} from './types';

export const ShellAccountSync = () => {
  const shellSelectedAccount = useShellSelectedAccount();
  const {
    accountList,
    isAccountListLoading,
    selectedAccount,
    setSelectedAccount,
  } = useAccountSelectorContext();

  useEffect(() => {
    if (shellSelectedAccount == null || isAccountListLoading) {
      return;
    }

    const resolvedAccount =
      accountList.find(account => account.id === shellSelectedAccount.id) ??
      accountList.find(
        account =>
          account.name === shellSelectedAccount.name &&
          (shellSelectedAccount.kind === 'personal'
            ? account.accountType === AccountType.Personal
            : account.accountType !== AccountType.Personal)
      );

    if (resolvedAccount != null && resolvedAccount.id !== selectedAccount?.id) {
      setSelectedAccount(resolvedAccount);
    }
  }, [
    accountList,
    isAccountListLoading,
    selectedAccount?.id,
    setSelectedAccount,
    shellSelectedAccount,
  ]);

  return null;
};

export const ShellAccountSelectorContextProviderWrapper: React.FC<{
  children?: React.ReactNode;
}> = ({children}) => (
  <AccountSelectorContextProviderWrapper>
    <ShellAccountSync />
    <ShellAdminModals />
    {children}
  </AccountSelectorContextProviderWrapper>
);

export const AppAccountSelectorProvider: React.FC<{
  children?: React.ReactNode;
}> = ({children}) =>
  isMountedInShell() ? (
    <ShellAccountSelectorContextProviderWrapper>
      {children}
    </ShellAccountSelectorContextProviderWrapper>
  ) : (
    <AccountSelectorContextProviderWrapper>
      {children}
    </AccountSelectorContextProviderWrapper>
  );
